import React from 'react'
import Image from '../images/lahore.jpg'

const Lahore = () => {
    return (
        <div className='cities'>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                    <div className="c_img">
                        <img src={Image} alt="Lahore" className='city_img' />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="cities_inner">
                        <h1>Lahore</h1>
                        <p>Lahore's origins reach into antiquity. The city has been controlled by numerous empires throughout the course of its history,
                             including the Hindu Shahis, Ghaznavids, Ghurids, and Delhi Sultanate by the medieval era. Lahore reached the height of its
                              splendour under the Mughal Empire between the late 16th and early 18th century and served as its capital city for many years.
                               The city was captured by the forces of the Afsharid ruler Nader Shah in 1739, then fell into a period of decay while being
                                contested between the Afghans and the Sikhs. Lahore eventually became the capital of the Sikh Empire in the early 19th century
                                 and regained some of its lost grandeur. Lahore was then annexed to the British Empire, and made capital of British Punjab.
                                  Lahore was central to the independence movements of both India and Pakistan, with the city being the site of both the declaration
                                   of Indian Independence, and the resolution calling for the establishment of Pakistan. It experienced some of the worst rioting during
                                    the Partition period preceding Pakistan's independence.[20] Following the success of the Pakistan Movement and subsequent partition of India in 1947,
                                     Lahore was declared the capital of Pakistan's Punjab province.</p>
                                     </div>
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default Lahore
